import { Link } from "react-router-dom";
import "./top-menu.scss";
import SubMenu from "../common/SubMenu/SubMenu";
import { useEffect, useState } from "react";
import { ABOUT_ME_ITEMS, GALLERY_ITEMS, STUDENTS_ITEMS } from "./constants";

type TopMenuProps = {};

const TopMenu = (props: TopMenuProps) => {
  const [selectedSubMenu, setSelectedsubMenu] = useState<string>("");
  let selectionTimeout = setTimeout(() => {});

  function handleSubMenDeSelection(selected?: string) {
    if (selected) {
      clearTimeout(selectionTimeout);
      selectionTimeout = setTimeout(() => setSelectedsubMenu(selected), 0);
    } else {
      selectionTimeout = setTimeout(() => setSelectedsubMenu(""), 500);
    }
  }

  useEffect(() => {
    return clearTimeout(selectionTimeout);
  }, []);

  return (
    <>
      <div className="top-menu-wrapper">
        <ul className="top-menu">
          <li
            className="top-menu__item"
            onMouseOver={() => handleSubMenDeSelection("home")}
            onMouseLeave={() => handleSubMenDeSelection()}
          >
            <Link to="/home" className="top-menu__item__link">
              Начало
            </Link>
          </li>
          <li
            className="top-menu__item"
            onMouseOver={() => handleSubMenDeSelection("about-me")}
            onMouseLeave={() => handleSubMenDeSelection()}
          >
            <Link to="/about-me" className="top-menu__item__link">
              За мен
              {selectedSubMenu === "about-me" ? (
                <SubMenu menuItems={ABOUT_ME_ITEMS} />
              ) : null}
            </Link>
          </li>
          <li
            className="top-menu__item"
            onMouseOver={() => handleSubMenDeSelection("students")}
            onMouseLeave={() => handleSubMenDeSelection()}
          >
            <Link to="/students" className="top-menu__item__link">
              За ученика
              {selectedSubMenu === "students" ? (
                <SubMenu menuItems={STUDENTS_ITEMS} />
              ) : null}
            </Link>
          </li>
          <li
            className="top-menu__item"
            onMouseOver={() => handleSubMenDeSelection("gallery")}
            onMouseLeave={() => handleSubMenDeSelection()}
          >
            <Link to="/gallery" className="top-menu__item__link">
              {selectedSubMenu === "gallery" ? (
                <SubMenu menuItems={GALLERY_ITEMS} />
              ) : null}
              Галерия
            </Link>
          </li>
          <li
            className="top-menu__item"
            onMouseOver={() => handleSubMenDeSelection("contacts")}
            onMouseLeave={() => handleSubMenDeSelection()}
          >
            <Link to="/contacts" className="top-menu__item__link">
              Контакти
            </Link>
          </li>
          {/* <li
            className="top-menu__item"
            onMouseOver={() => handleSubMenDeSelection("attestation")}
          >
            <Link to="/attestation" className="top-menu__item__link">
              Атестация
            </Link>
          </li> */}
        </ul>
      </div>
    </>
  );
};

export default TopMenu;
